import { Component, inject, Input, NgModule, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CrmTranslatePipe } from 'common-module/translate';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-support-detail',
  template: `
    <div class="support">
      <h2>{{ title | crmTranslate }}</h2>
      <div class="support__body">
        {{ content | crmTranslate }}
      </div>
      <div class="support__contact">{{ email | crmTranslate }}</div>
      <div class="support__contact">{{ phone | crmTranslate }}</div>
      <button
        nz-button
        nzType="primary"
        class="support__submit"
        (click)="handleSubmit()"
      >
        {{ 'support.action.confirm' | crmTranslate }}
      </button>
    </div>
  `,
  styleUrls: ['./support-detail.component.less']
})
export class SupportDetailComponent implements OnInit {
  @Input() public onSubmit: () => void;
  @Input() public title = 'techSupport.modal.title';
  @Input() public content = 'techSupport.modal.content';
  public phone = 'techSupport.modal.phone';
  public email = 'techSupport.modal.email';

  private modalData = inject(NZ_MODAL_DATA);

  ngOnInit() {
    this.onSubmit = this.modalData?.onSubmit;
  }

  public handleSubmit() {
    if (this.onSubmit) {
      this.onSubmit();
    }
  }
}

@NgModule({
  declarations: [SupportDetailComponent],
  exports: [SupportDetailComponent],
  imports: [NzButtonModule, CrmTranslatePipe]
})
export class SupportDetailModule {}
